import { Box, HStack, VStack, Text } from '@chakra-ui/react';
import React, { ReactElement } from 'react';
import { DosageFormIcon, Substance } from '@novaheal/types';
import { useBreakpoint } from 'hooks/utils/layout/useBreakpoint';
import { Breakpoints } from 'types/breakpoints';
import { FavoriteIcon, FavoriteSolidIcon } from 'assets/icons/v2';
import { NovaIconButton } from 'components/ui/NovaIconButton';
import MedicationApplicationTypeIcons from './MedicationApplicationTypeIcons';

type Props = {
  name: string;
  substanceGroup?: Substance[];
  dosageFormIcons: DosageFormIcon[];
  trademark: string[];
  handleLikeChange: () => void;
  isLiked?: boolean | null;
};

export const MedicationInfo = ({
  name,
  substanceGroup,
  dosageFormIcons,
  trademark,
  isLiked = false,
  handleLikeChange,
}: Props): ReactElement => {
  const isDesktop = useBreakpoint(Breakpoints.DESKTOP);

  return (
    <Box
      p={{ base: '0px 20px', md: '0 40px' }}
      backgroundColor={{ md: 'background.primary' }}
      borderRadius={{ md: '2xl' }}
      position="relative"
    >
      {isDesktop && (
        <HStack position="absolute" top="l" right="l">
          <NovaIconButton
            variant="primary"
            icon={isLiked ? FavoriteSolidIcon : FavoriteIcon}
            size="l"
            iconProps={{
              width: '30px',
              height: '30px',
              color: 'icon.accent',
            }}
            onClick={handleLikeChange}
          />
        </HStack>
      )}
      <VStack align="left" gap="4" p={{ base: '2px 0 4px', md: '0' }}>
        <Text as="h1" textStyle="h1.semibold" mt="3" color="text.primary" mb="4">
          {name}
        </Text>
        <Text as="h2" textStyle="body.m.regular" mt="3" color="text.primary" mb="4">
          {substanceGroup?.map((substance: Substance) => substance.name).join(', ')}
        </Text>
        <MedicationApplicationTypeIcons dosageFormIcons={dosageFormIcons} />
        <Text as="h2" textStyle="body.m.italic" mt="3" color="text.quaternary">
          {trademark.join(', ')}
        </Text>
      </VStack>
    </Box>
  );
};
